import SolutionsCardsScene from "./SolutionsCardsScene";

// Orchestrateur fin (mouse/resize/visibilité/rAF) autour de SolutionsCardsScene, sur le même
// principe que HomeBanner3D/HomeBannerScene : le moteur 3D ne dépend d'aucune lib du bundle
// principal, il expose juste setActiveIndex() pour être piloté depuis un Swiper externe.
export default class SolutionsCards3D {
	constructor(canvas, { cards, mode, modelUrl }) {
		this.canvas = canvas;
		this.mode = mode;
		this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		this.visible = true;
		this.raf = null;

		this.scene = new SolutionsCardsScene({ canvas, cards, mode, modelUrl, reducedMotion: this.reducedMotion });

		this._onMouseMove = (e) => {
			const x = e.clientX / window.innerWidth - 0.5;
			const y = e.clientY / window.innerHeight - 0.5;
			this.scene.setMouseTilt(x, y);
			// Position brute en plus du tilt : la scène s'en sert pour savoir quelle carte est
			// survolée (elle écarte elle-même un pointeur situé hors du canvas).
			this.scene.setHoverPointer(e.clientX, e.clientY);
		};
		window.addEventListener("mousemove", this._onMouseMove);

		this._onResize = () => this.scene.resize();
		window.addEventListener("resize", this._onResize);

		if (mode === "auto" && !this.reducedMotion) {
			this._onWheel = (e) => {
				if (this.visible) this.scene.boostSpeed(Math.abs(e.deltaY) * 0.0016);
			};
			window.addEventListener("wheel", this._onWheel, { passive: true });

			let lastTouchY = 0;
			this._onTouchStart = (e) => {
				lastTouchY = e.touches[0].clientY;
			};
			this._onTouchMove = (e) => {
				const y = e.touches[0].clientY;
				if (this.visible) this.scene.boostSpeed(Math.abs(lastTouchY - y) * 0.008);
				lastTouchY = y;
			};
			window.addEventListener("touchstart", this._onTouchStart, { passive: true });
			window.addEventListener("touchmove", this._onTouchMove, { passive: true });
		}

		this._observer = new IntersectionObserver(
			(entries) => {
				this.visible = entries[0].isIntersecting;
			},
			{ threshold: 0 }
		);
		this._observer.observe(canvas);

		this._tick = () => {
			if (this.visible) this.scene.update();
			this.raf = requestAnimationFrame(this._tick);
		};

		this.ready = this._init();
	}

	async _init() {
		await this.scene.load();
		this._tick();
	}

	setActiveIndex(index, animate = true) {
		this.scene.setActiveIndex(index, animate);
	}

	setContinuousIndex(value) {
		this.scene.setContinuousIndex(value);
	}

	linkAt(clientX, clientY) {
		return this.scene.linkAtPointer(clientX, clientY);
	}

	destroy() {
		cancelAnimationFrame(this.raf);
		window.removeEventListener("mousemove", this._onMouseMove);
		window.removeEventListener("resize", this._onResize);
		if (this._onWheel) window.removeEventListener("wheel", this._onWheel);
		if (this._onTouchStart) window.removeEventListener("touchstart", this._onTouchStart);
		if (this._onTouchMove) window.removeEventListener("touchmove", this._onTouchMove);
		this._observer.disconnect();
		this.scene.destroy();
	}
}
